import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const hasGateAccess = sessionStorage.getItem('mpm_gate_access') === 'true';

  if (!hasGateAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
